import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesProductsAction';
import fetchApi from "./fetchApi";

// TODO: Remove the hardcoded product nid and replace with selected products (as JSON array: [2,4,12,7])
function fetchFeedingGuidelinesProducts(products, amounts) {
  const productsString = JSON.stringify(products);
  const amountsString = JSON.stringify(amounts);
  return fetchApi(`/v1/fc_api/feeding_guidelines_product_resource?products=${productsString}&weights=${amountsString}`, fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesProducts;
